import { Component} from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-politica-privacidad',
  templateUrl: './politica-privacidad.component.html'
})
export class PoliticaPrivacidadComponent {

  constructor(private location: Location) {}
  
  return(){
    this.location.back();
  }

}
